import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckoutConfirmationComponentDef } from '@df/checkout/checkout-confirmation.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
@Component({
    selector: 'checkout-confirmation',
    templateUrl: './checkout-confirmation.html',
    standalone: true,
    imports: [NgClass, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutConfirmationComponent extends CheckoutConfirmationComponentDef {}
